class Adapter {
  constructor() {
    this.functionSets = [];
  }

  push(functionSet) {
    this.functionSets.push(functionSet);
  }

  async execute() {
    const functionSetsLength = this.functionSets.length;

    for (let i = 0; i < functionSetsLength; i++) {
      const functionSet = this.functionSets.shift();
      const functionMethod = functionSet[0];
      const functionArgs = functionSet[1] ? functionSet[1] : [];
      await functionMethod(...functionArgs);
    }
  }
}

export default {
  Adapter,
};
